import { PropsWithChildren } from 'react';
import { SHProvider } from '@libs/creditkit';
import { useDogxContext } from '@libs/dogx';

const SHProviderExperiment = ({ children }: PropsWithChildren) => {
  const dxScOffers = 'dx-sc-offers';
  const hasOffersEndpoint = 'has-offers-endpoint';

  const { getExperimentVariant } = useDogxContext();
  const singleCallMode = (getExperimentVariant(dxScOffers) ?? 'control') === hasOffersEndpoint;

  return (
    <SHProvider
      appName="cp"
      mode={import.meta.env.VITE_ENV}
      shKey={import.meta.env.VITE_SORTING_HAT_API_KEY}
      baseURL={import.meta.env.VITE_SORTING_CREDIT_API_URL}
      identifier="userDocument"
      singleCallMode={singleCallMode}
    >
      {children}
    </SHProvider>
  );
};

export default SHProviderExperiment;
